module.exports = __webpack_public_path__ + "assets/img/block-e5a22a41.png";